
import * as React from 'react';
import { IOverflowContainerViewProps } from './overflow-container';

const OverflowContainerView: React.FC<IOverflowContainerViewProps> = props => {
    const { content, currentClass, btn, config: { cssClassName } } = props;

    return (
        <div className={`${currentClass} ${cssClassName || ''}`}>
            {props.config.showToggleButton ? btn : <></>}
            {content}
        </div>
    );
};

export default OverflowContainerView;